import { createSelector } from 'reselect';
import { getOr } from 'lodash/fp';
import { stringFormatter } from 'helpers/i18n';

const formatters = {
  similarResultsFound: stringFormatter(__('search.similarResultsFound')),
};

const getResultsAmount = getOr(0, ['resultsAmount']);

const getVehicleMakeModel = getOr('', ['filters', 'vehicle', 0, ['value']]);

const getSimilarResultsMarkup = createSelector(
  getResultsAmount,
  getVehicleMakeModel,
  (amount, makeModel) => ({
    __html: formatters.similarResultsFound({
      results: `<strong>${amount} ${makeModel}</strong>`,
    }),
  }),
);

export default {
  vehicleMakeModel: getVehicleMakeModel,
  similarResultsMarkup: getSimilarResultsMarkup,
};
